<template>
  <div class="group-box">
    <!-- <div class="box-title">
      <div class="title f-16 f-c-999">基础设置</div>
    </div> -->
    <div class="box-list">
      <a-form :label-col="{ span: 2 }" :model="form" :wrapper-col="{ span: 8, offset: 1 }" autocomplete="off" name="basic">
        <a-form-item label="入住时间" name="in_time">
          <a-time-picker v-model:value="form.inTime" :allowClear="false" :showNow="false" format="HH:mm" @change="editInTime" />
        </a-form-item>
        <a-form-item label="退房时间" name="out_time">
          <a-time-picker v-model:value="form.outTime" :allowClear="false" :showNow="false" format="HH:mm" @change="editOutTime" />
        </a-form-item>
        <a-form-item label="欢迎语" name="welcome">
          <a-textarea v-model:value="form.welcome" placeholder="请输入欢迎语" />
        </a-form-item>
        <a-form-item label="入住说明" name="instructions">
          <a-textarea v-model:value="form.instructions" placeholder="请输入地址" />
        </a-form-item>
        <a-form-item label="身份验证" name="check_identity">
          <a-select ref="select" v-model:value="form.check_identity" style="width: 100%">
            <a-select-option v-for="item in searchList.checkIdentity.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="身份证件要求" name="certificate_requirements">
          <a-select ref="select" v-model:value="form.certificate_requirements" style="width: 100%">
            <a-select-option v-for="item in searchList.certificateRequirements.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="门锁功能" name="status">
          <a-select ref="select" v-model:value="form.open_type" :showSearch="false" mode="multiple" placeholder="请选择" style="width: 100%">
            <a-select-option v-for="item in form.openType || []" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="开放功能" name="status">
          <a-select ref="select" v-model:value="form.open_fun" :showSearch="false" mode="multiple" placeholder="请选择" style="width: 100%">
            <a-select-option v-for="item in form.openFun || []" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="默认押金" name="welcome">
          <a-input-number v-model:value="form.deposit" :min="0"> </a-input-number>
          元，0或者空则不收取押金
        </a-form-item>

        <a-form-item :wrapper-col="{ offset: 5, span: 16 }">
          <a-button html-type="submit" type="primary" @click="saveConfig">保存 </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue';
import { companyBasics, companyEdit, getSearchList } from '@/api/api';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';

export default {
  components: {},
  setup() {
    const config = reactive({
      searchList: {
        checkIdentity: { list: [] },
        certificateRequirements: { list: [] },
      },
      form: {},
      getSearch() {
        // 获取查询参数列表
        getSearchList().then(res => {
          config.searchList = res.data;
        });
      },
      //   保存设置
      saveConfig() {
        console.log(config.form);
        let params = {
          in_time: config.form.in_time,
          out_time: config.form.out_time,
          welcome: config.form.welcome,
          instructions: config.form.instructions,
          check_identity: config.form.check_identity,
          certificate_requirements: config.form.certificate_requirements,
          open_door_type: config.form.open_type.toString(),
          open_fun: config.form.open_fun.toString(),
          deposit: config.form.deposit,
        };
        companyEdit(params).then(res => {
          message.success(res.msg);
          config.getConfig();
        });
      },

      editInTime(e) {
        config.form.in_time = dayjs(e).format('HH:mm');
      },
      editOutTime(e) {
        config.form.out_time = dayjs(e).format('HH:mm');
      },

      // 获取设置
      getConfig() {
        companyBasics().then(res => {
          config.form = res.data;
          config.form.inTime = dayjs(config.form.in_time, 'HH:mm');
          config.form.outTime = dayjs(config.form.out_time, 'HH:mm');
          config.form.open_type = res.data.openType.some(i => i.selected) ? res.data.openType.filter(i => i.selected).map(i => i.id) : [];
          config.form.open_fun = res.data.openFun.some(i => i.selected) ? res.data.openFun.filter(i => i.selected).map(i => i.id) : [];
          console.log(config.form);
        });
      },
      //  上传图片
      uploadLogo(info) {
        if (info.file.status === 'done') {
          config.form.logo = info.file.response.data.url;
        }
      },
    });

    onMounted(() => {
      config.getConfig();
      config.getSearch();
    });

    return {
      ...toRefs(config),
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}

.group-box {
  background-color: #fff;
  width: 100%;
  //   box-shadow: 0 0 5px #99999933;
  .box-title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
    }

    .btn {
    }
  }

  .box-list {
    padding: 20px;

    .list-lef {
      .lef-name {
        margin-bottom: 5px;
      }

      .lef-num {
      }
    }

    .list-rig {
      display: flex;
    }
  }
}
</style>
